import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import HeaderProfile from '@/components/HeaderProfile.vue';
import AjaxButton from '@/components/AjaxButton.vue';
import { updateUser } from '@/services/UserService';
let PersonalInfoEdit = class PersonalInfoEdit extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.user = this.$store.state.user;
        this.error = undefined;
        this.missingData = false;
        this.formData = {
            name: '',
            email: '',
            phone: ''
        };
        this.formErrors = {
            name: false,
            email: false,
            phone: false,
            phoneRepeat: false
        };
    }
    async updateData() {
        if (!this.validForm())
            return;
        const update = await updateUser(this.user, this.formData.name, this.formData.email, this.formData.phone, this.user.authToken);
        if (update) {
            await this.$store.dispatch('login', update);
            await this.$router.back();
        }
    }
    validForm() {
        this.formErrors = { name: false, email: false, phone: false, phoneRepeat: false };
        if (!this.formData.name)
            this.formErrors.name = true;
        if (!this.formData.email)
            this.formErrors.email = true;
        if (this.formData.phone.length !== 10)
            this.formErrors.phone = true;
        if (this.checkDigitRepeated(this.formData.phone, 5))
            this.formErrors.phoneRepeat = true;
        for (const error of Object.values(this.formErrors)) {
            if (error == true)
                return false;
        }
        return true;
    }
    checkDigitRepeated(input, repeat) {
        const regex = new RegExp("(\\d)\\1{" + repeat + "}", "g");
        return !!input.match(regex);
    }
    created() {
        this.formData.name = this.user.name;
        this.formData.email = this.user.email;
        this.formData.phone = this.user.phone;
        if (!this.formData.name || !this.formData.email || !this.formData.phone) {
            this.missingData = true;
        }
    }
    cancel() {
        this.$router.push('/personalinfo');
    }
};
PersonalInfoEdit = __decorate([
    Component({
        components: {
            CommonHeader,
            HeaderProfile,
            AjaxButton,
        },
    })
], PersonalInfoEdit);
export default PersonalInfoEdit;
